import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Avatar, message, Modal, Typography } from 'antd';

import {
	RssFeedCategoriesIconsEnum,
	RssFeedCategoriesTranslationsEnum,
} from '../../../../enums/rss-feed-categories';
import { RssFeedRagionsTranslationsEnum } from '../../../../enums/rss-feed-regions';
import RssFeedsApi from '../../../../services/sdks/rss-feeds';
import Fallback from '../../../../components/Fallback';
import { RssFeedDetailsContainer } from './styles';
import { format } from 'date-fns';
import { resolveFileSrc } from '../../../../helpers/fileSrcResolver';
import env from '../../../../config/env';

export const RssFeedDetailsModal = ({ isVisible, rssFeed, onClose }) => {
	const [isLoading, setIsLoading] = useState(true);
	const [data, setData] = useState(null);

	useEffect(() => {
		const fetchRssFeed = async () => {
			setIsLoading(true);

			try {
				const { data } = await RssFeedsApi.getRssFeed(rssFeed._id);
				setData(data.rssFeed);
			} catch (error) {
				message.error('Houve um erro ao buscar os dados, tente novamente');
			}

			setIsLoading(false);
		};

		if (isVisible && rssFeed._id) {
			fetchRssFeed();
		}
	}, [isVisible, rssFeed._id]);

	const Icon = useMemo(() => (data ? RssFeedCategoriesIconsEnum[data.category] : null), [data]);
	const coverSrc = useMemo(() => {
		return data?.coverImage
			? resolveFileSrc({
					fileName: data?.coverImage,
					folder: ['profile_pics'],
					bucket: env.miscS3Bucket,
			  })
			: null;
	}, [data]);

	if (!isVisible) {
		return null;
	}

	return (
		<Modal
			onCancel={onClose}
			title='Detalhes do Feed RSS'
			visible={isVisible}
			footer={null}
			width={800}>
			{isLoading ? (
				<Fallback title='Carregando' message='Buscando notícias...' />
			) : (
				<RssFeedDetailsContainer>
					<header>
						<Avatar
							style={{ minWidth: '48px', minHeight: '48px', borderRadius: 12 }}
							src={coverSrc}
						/>
						<Typography.Title level={3}>{data?.title}</Typography.Title>
					</header>

					<div className='infos'>
						<div>
							<span>Categoria</span>
							<strong>
								{Icon && <Icon />}
								{RssFeedCategoriesTranslationsEnum[data.category]}
							</strong>
						</div>
						<div>
							<span>Abrangência</span>
							<strong>{RssFeedRagionsTranslationsEnum[data.region]}</strong>
						</div>
						<div>
							<span>Último Post</span>
							<strong>
								{data.metadata?.lastUpdateAt
									? format(new Date(data.metadata?.lastUpdateAt), 'dd/MM/yyyy HH:mm:ss')
									: '-'}
							</strong>
						</div>
					</div>

					<div className='news'>
						<Typography.Title level={4}>Notícias</Typography.Title>
						{data.metadata ? (
							<ul>
								{data?.metadata?.items?.map((item) => (
									<li key={item.id}>
										<header>
											<small>{item.author ? item.author : 'Autor não identificado'}</small>
											<strong>{item.title}</strong>
										</header>

										<span>{item.content}</span>

										<a target='_blank' href={item.url} rel='noreferrer'>
											{item.url}
										</a>
									</li>
								))}
							</ul>
						) : (
							<Alert
								showIcon
								style={{ width: '100%' }}
								type='warning'
								message='RSS instável'
								description='O serviço de RSS está momentaneamente fora do ar, tente novamente mais tarde'
							/>
						)}
					</div>
				</RssFeedDetailsContainer>
			)}
		</Modal>
	);
};
